import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: true,
    error: null,
    membersByTeamId: {},
};

const analyticTeamMemberSlice = createSlice({
    name: 'analyticTeamMember',
    initialState,
    reducers: {
        setAnalyticTeamMember(state, action) {
            const { teamId, members } = action.payload || {};
            state.membersByTeamId[teamId] = members;
            state.loading = false;
            state.error = null;
        },
        purgeAnalyticTeamMember(state, action) {
            const teamId = action.payload;
            delete state.membersByTeamId[teamId];
            state.loading = false;
            state.error = null;
        },
        resetAnalyticTeamMember: () => initialState,
    },
});

export const {
    setAnalyticTeamMember,
    purgeAnalyticTeamMember,
    resetAnalyticTeamMember,
} = analyticTeamMemberSlice.actions;

// Selectors
export const selectAnalyticTeamMember = (teamId) => (state) =>
    state.analyticTeamMember.membersByTeamId[teamId] || [];

export default analyticTeamMemberSlice.reducer;
